var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-error-message"},[_c('WsIcon',[_vm._v("info")]),_c('div',{staticClass:"ws-error-message__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }